$(document).ready(function () {
    var procurementForm = $('#procurementForm');
    if (procurementForm.length) {
        procurementForm.submit();
    }
});